import axios from 'axios'
var jwt = require('jsonwebtoken');
import FingerprintJS from '@fingerprintjs/fingerprintjs-pro'


const getDefaultState = () => {
    return {
        token: false,
        contract: null,
        renewing: false,
        token_expires: false,
        token_expired: false,
        apoMobileNo: false,
        admin: false,
        ScreeningPortal: false,
        developer: false,
        auth: false,
        authError: false,
        clients: [],
        covidparams: {
            rox: null,
            cy5: null,
        },
        user: {
            kd: null,
            name: null,
            id: null,
        },        
    }
  }

export const state = getDefaultState()



export const getters = {
    getSMSNo(state) {
        return state.apoMobileNo;
    },
    contractSigned(state) {
        return state.contract;
    },
    covidParams(state) {
        return state.covidparams;
    },
    AccessTokenExpired(state) {
        return state.token_expired;
    },
    AccessTokenData(state) {
        return jwt.decode(state.token);
    },
    isAdmin(state) {
        return state.admin;
    },
    developer(state) {
        return state.developer;
    },
    person(state) {
        if(state.user.person == "") {
            return "Organisations Admin";
        } else {
            return state.user.person;
        }
    },
    autherror(state) {
        return state.authError;
    },
    user(state) {
        return state.user;
    },
    auth(state) {
        return state.auth == true;
    },
    accessToken(state) {
        return state.token;
    },
    getClients(state) {
        return state.clients;
    },
    ScreeningPortalEnabled(state) {
        return state.ScreeningPortal == true;
    },
    ScreeningPortalDelay(state) {
        return parseFloat(state.ScreeningPortalDelay);
    }
  }

export const mutations = {
    ClearLogin(state, force) {
        state.user = {}
        state.auth = false;
        state.token =false;
    },
    SetUser(state, user) {
        state.user = user;
    },
    SetToken(state, access_token) {
        state.token = access_token;
        state.token_expires = jwt.decode(access_token).exp;
        state.token_expired = false;
        localStorage.setItem("at", state.token);    
        state.auth = true;
    },
    SetAuthError(state,error) {
        state.authError = error;
    },
    ClearaState(state) {
        state.tests = {};
    },
    setAdmin(state, admin) {
        state.admin = admin;
    },
    setClients(state, clients) {
        state.clients = clients;
    },
    SetScreeningPortal(state, portal){
        state.ScreeningPortal = portal;
    },
    SetScreeningPortalDelay(state, delay) {
        state.ScreeningPortalDelay = parseFloat(delay);
    },
    SetCovidParameters(state, parameter) {
        let { cta = null, ctb = null, rox = null,cy5 = null } = parameter;
        state.covidparams.rox = rox;
        state.covidparams.cy5 = cy5;
    },
    TokenExpired(state, ss) {
        state.token_expired = ss;
    },
    setContract(state, contract) {
        state.contract = contract;
    },
    setSMSNumber(state, num) {
        state.apoMobileNo = num;
    }
}

export const actions = {
    QRCodeAuth(state, token) {
        return new Promise((resolve, reject) => {
            axios.get("/api/qrlogin?token="+token).then((response) => {
                let { token = false, user= null} = response.data;
                state.commit("SetToken", token);
                state.dispatch("FetchUserParameters")
                state.commit("SetUser", user);
                state.dispatch("LoadInitialData")
                resolve(true);
            }).catch(() => {
                reject(false);
            })          
        })       
    },
    ClearState(state) {
        Object.assign(state, getDefaultState())
    },
    Logout(state) {
        state.commit("ClearLogin", true);
        state.dispatch("ClearState");
    },
    FetchUserClients(state) {
        return new Promise((resolve, reject) => {
            axios.get("/api/clients", { headers: { Authorization: 'Berear '+state.getters.accessToken} })
            .then((response) => {
                state.commit("setClients", response.data)
            })
        });
    },
    FetchUserParameters(state) {
        return new Promise((resolve, reject) => {
            axios.get("/api/parameters", { headers: { Authorization: 'Berear '+state.getters.accessToken} })
            .then((response) => {
                state.commit("setAdmin", response.data.admin)
                state.commit("setContract", response.data.contract)
                state.commit("setSMSNumber", response.data.sms);
                if(response.data.admin) {
                    state.dispatch("FetchUserClients", true);
                }
                state.commit("SetScreeningPortal", response.data.screeningPortal);
                state.commit("SetScreeningPortalDelay", parseFloat(response.data.screeningPortalDelay));
            })
        });
    },
    FetchCovid19Parameters(state) {
        return new Promise((resolve, reject) => {
            axios.get("https://poc.procomcure.com/api/parameter")
            .then((r) => {
                state.commit("SetCovidParameters", r.data);
            })
        })
    },
    ForceRelogin(state) {
        console.log("FORCE RELOADI");
    },
    RefreshToken(state) {
        return new Promise((resolve, reject) => {
            axios.post("/api/auth/renewToken", {}, { headers: { Authorization: 'Berear '+state.getters.accessToken} })
            .then((r) => {
                if(r.status == 201) {
                    state.commit("SetToken", r.data.token);
                    state.dispatch("LoadInitialData");
                    resolve(true);
                }
            })
            .catch((e) => {
                reject(false);
            })
        });
    },

    TryAutoLogin(state,data) {
        return new Promise((resolve, reject) => {
            const fpPromise = FingerprintJS.load({ token: 'uR5Y3Qow1xu0SFcbVmFP', region: "eu" })
            fpPromise
            .then(fp => fp.get())
            .then(result => {
                axios.get("/api/users/"+result.visitorId)
                .then((r) => {
                    if(r.data.success) {
                        resolve(r.data.email);
                    } else {
                        reject(false);
                    }
                })
            })
        });
    },

    Login(state,data) {
        return new Promise((resolve, reject) => {

            const fpPromise = FingerprintJS.load({ token: 'uR5Y3Qow1xu0SFcbVmFP', region: "eu" })
            fpPromise
            .then(fp => fp.get())
            .then(result => {
                var base = btoa(data.username+":"+data.password);
                axios.post("/api/auth", { fp: result.visitorId }, { headers: { 'Authorization': 'Basic '+base } })
                .then((response) => {
                    let { token = false, user= null} = response.data;
                    state.commit("SetToken", token);
                    state.commit("SetUser", user);
                    state.dispatch("LoadInitialData")
                    state.dispatch("FetchUserParameters")
                    state.dispatch("FetchCovid19Parameters")
                    setInterval(() => {
                        if(Date.now()+15000 > state.state.token_expires*1000) {
                            state.commit("TokenExpired", true);
                        }
                    }, 1500);            
                    resolve(user);
                })
                .catch(() => {
                    state.commit("SetAuthError", true)
                    setTimeout(() => {
                        state.commit("SetAuthError", false)
                    }, 1500)                
                    reject(false);
                })
            })
        })
    }
}


export default {
    namespaced: false,
    state,
    getters,
    actions, 
    mutations
  }